// src/pages/no-access/noAccess.js
import React from 'react';

const NoAccessPage = () => {
  const handleGoToLogin = () => {
    window.location = '/login';
  };

  return (
    <div style={{ padding: '2rem', textAlign: 'center' }}>
      <h1 style={{ color: 'red' }}>Access Denied</h1>
      <p>
        You do not have access to this application. Please contact your
        administrator.
      </p>
      <button
        onClick={handleGoToLogin}
        style={{
          padding: '0.5rem',
          backgroundColor: '#460073',
          color: 'white',
          cursor: 'pointer'
        }}
        className='btn mt-4'
      >
        Go to Login
      </button>
    </div>
  );
};

export default NoAccessPage;
